























import { computed, defineComponent, ref } from "@vue/composition-api";
import { TagInfo, TagInfoType } from "@scrile/api-provider/dist/api/TagsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import ModalView from "@/components/ModalView";
import TagsController from "../TagsController";

export default defineComponent({
  name: "SelectTagsModal",
  components: { BaseButton, TagsController, ModalView },
  props: {
    value: { type: Boolean, required: true },
    selectedTags: { type: Array as () => TagInfo[], required: true },
    tagsType: { type: String as () => TagInfoType, required: true },
    title: { type: String, default: $t("Categories") },
  },
  setup(props, { emit }) {
    const clearCb = ref<Function>(() => {});

    const showClear = computed(() => props.selectedTags.length > 0);

    const setClearCb = (cb: Function) => {
      clearCb.value = cb;
    };

    const clear = () => {
      clearCb.value();
    };

    const save = (tags: TagInfo[]) => {
      emit("select", tags);
    };

    return {
      clearCb,
      showClear,
      setClearCb,
      save,
      clear,
    };
  },
});
